import React from 'react';
import DisplayCategory from '../display-category/DisplayCategory';
import MedicalPrescription from '../medical-prescription/MedicalPrescription';
import styles from '../add-edit-item.scss';
// import {useSelector} from 'react-redux';

const ItemInfoContainer = (props) => {
    return (
        <div className={styles["item-info-container"]}>
            {!props.permissions.isAutomatedCategorization && <DisplayCategory productData={props.productData} />}
            {props.permissions.uploadPrescription && <MedicalPrescription {...props} />}
        </div>
    )
}

// const ItemInfoContainerHOC = CollapsibleSectionHOC(ItemInfoContainer, 'Product Name, Category & Description');

// export default ItemInfoContainerHOC;
export default ItemInfoContainer;